// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"871ed923","453":"8d7f3a60","732":"b9378afb","977":"8d6ec2c9"}[chunkId] + ".chunk.js");